// Google Calendar integration has been moved to the Profile page.
function Settings() {
  return null;
}

export default Settings;
